module.exports = __webpack_public_path__ + "img/parallax.6da706da.jpg";